import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';

Font.register({
  family: 'Courier',
  fonts: [{ src: 'https://fonts.gstatic.com/s/courierprime/v6/u-4k0qWljRw-PdeL2uhquylEeA.ttf' }],
});

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: 'Helvetica',
    borderWidth: 2,
    borderColor: '#000',
    borderStyle: 'solid',
  },
  header: {
    textAlign: 'center',
    marginBottom: 10,
  },
  bold: {
    fontWeight: 'normal',
  },

  // Table header row style
  tableHeader: {
    flexDirection: 'row',
    marginTop: 5,
  },

  // Header cell style
  headerCell: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderColor: '#ccc',
    fontWeight: 'bold',
  },

  headerCell1: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderColor: '#ccc',
    fontWeight: 'bold',
  },

  // Data row container
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#ccc',
  },

  // Data cell style

  // Add bottom border to last row
  lastRowCell: {
    // borderBottomWidth: 1,
    // borderColor: '#ccc',
  },

  footer: {
    marginTop: 30,
    fontSize: 10,
  },

  rowTotal: {
    flexDirection: 'row',
    paddingVertical: 2,
    paddingHorizontal: 4,
  },

  cellTotal: {
    flex: 1,
    paddingVertical: 2,
    paddingHorizontal: 4,
    marginLeft: 4,
  },

  cell: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: '#ccc',
  },

  cell1: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderRightWidth: 1,
    borderColor: '#ccc',
  },

  detailsRow: {
    marginBottom: 3,
  },

  labelText: {
    textAlign: 'left',
    // fontWeight: 'bold',
  },

  amountText: {
    textAlign: 'right',
    // fontWeight: 'bold',
  },
});

const InvoicePDF = ({ customerDetails, products, totalPrice }) => {
  const vat = (Number(totalPrice) * 18) / 100;
  const totalWithVAT = Number(totalPrice) + vat;
  const formattedDate = new Date().toLocaleString();

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <View style={styles.header}>
          <Text style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 2 }}>SRI KANTH PROFESSIONAL KITCHEN (PVT) LTD</Text>
          <Text>No 06, Kotugodalla Veediya, Kandy</Text>
          <Text>T. 081 2237855 | F. 081 2237620 | E. info@srikanthprofessional.com</Text>
          <Text>W. www.srikanthprofessional.com</Text>
          <Text>VAT Reg. Number: 114237388 - 7000</Text>
          <Text style={{ marginTop: 6, fontSize: 14, fontWeight: 600 }}>Tax Invoice</Text>
        </View>

        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 }}>
          {/* Left Column */}
          <View style={{ flex: 1 }}>
            <Text style={{ fontWeight: 'bold', marginBottom: 5 }}>Customer Details</Text>

            <Text style={styles.detailsRow}>Name: {customerDetails.customerName}</Text>
            <Text style={styles.detailsRow}>Address: {customerDetails.customerAddress}</Text>
            <Text style={styles.detailsRow}>REF No: {customerDetails.customerREFNo}</Text>
            {customerDetails.customerVatNo && <Text style={styles.detailsRow}>VAT No: {customerDetails.customerVatNo}</Text>}
          </View>

          {/* Right Column */}
          <View style={{ flex: 1, alignItems: 'flex-end' }}>
            <Text style={{ fontWeight: 'bold', marginBottom: 5 }}>Invoice Details</Text>
            <Text style={styles.detailsRow}>Invoice No: {customerDetails.invoiceNo}</Text>
            <Text style={styles.detailsRow}>Date: {formattedDate}</Text>
            <Text style={styles.detailsRow}>REF No: {customerDetails.SKREFNo}</Text>
          </View>
        </View>
        {/* <Text>VAT Reg. Number: 409009107700</Text> */}

        {/* Table */}
        <View style={styles.tableHeader}>
          <Text style={styles.headerCell}>Product</Text>
          <Text style={styles.headerCell1}>Quantity</Text>
          <Text style={styles.headerCell1}>Unit Price</Text>
          <Text style={{ ...styles.headerCell1, borderRightWidth: 1 }}>Total</Text>
        </View>
        {products
          .filter((item) => item.enteredQuantity > 0)
          .map((item, i, filteredProducts) => {
            const name = item.productName || item.product.productName;
            const qty = item.enteredQuantity;
            const price = Number(item.sellingPrice || item.product.sellingPrice);
            const total = price * qty;

            const isLastRow = i === filteredProducts.length - 1;

            return (
              <View style={styles.row} key={i} wrap={false}>
                <Text style={[styles.cell, isLastRow && styles.lastRowCell]}>{name}</Text>
                <Text style={[styles.cell1, isLastRow && styles.lastRowCell]}>{qty}</Text>
                <Text style={[styles.cell1, isLastRow && styles.lastRowCell]}>Rs.{price.toFixed(2)}</Text>
                <Text style={[styles.cell1, isLastRow && styles.lastRowCell]}>Rs.{total.toFixed(2)}</Text>
              </View>
            );
          })}

        {/* Totals */}
        <View style={{ marginTop: 10 }} wrap={false}>
          {Number(customerDetails.labourCharges) > 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Labour Charges</Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.labourCharges).toFixed(2)}</Text>
            </View>
          )}
          {Number(customerDetails.transport) > 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Transport</Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.transport).toFixed(2)}</Text>
            </View>
          )}
          {Number(customerDetails.cleaningLiquid) > 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Cleaning Liquid</Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.cleaningLiquid).toFixed(2)}</Text>
            </View>
          )}
          {Number(customerDetails.cottonWaste) > 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Cotton Waste</Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.cottonWaste).toFixed(2)}</Text>
            </View>
          )}
          {Number(customerDetails.miscellaneous) > 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Miscellaneous</Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.miscellaneous).toFixed(2)}</Text>
            </View>
          )}
          {Number(customerDetails.workshopCharges) > 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Workshop Charges</Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.workshopCharges).toFixed(2)}</Text>
            </View>
          )}

          {Number(customerDetails.outsideWorkshopCharges) > 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Outside Workshop Charges</Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.outsideWorkshopCharges).toFixed(2)}</Text>
            </View>
          )}

          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.labelText]}>Discount</Text>
            <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(customerDetails.discount).toFixed(2)}</Text>
          </View>
          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.labelText]}>Total Price</Text>
            <Text style={[styles.cellTotal, styles.amountText]}>Rs.{(Number(totalPrice) + Number(customerDetails.discount)).toFixed(2)}</Text>
          </View>

          {Number(customerDetails.discount) !== 0 && (
            <View style={styles.rowTotal}>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal]}></Text>
              <Text style={[styles.cellTotal, styles.labelText]}>Total Price with Discount </Text>
              <Text style={[styles.cellTotal, styles.amountText]}>Rs.{Number(totalPrice).toFixed(2)}</Text>
            </View>
          )}

          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.labelText]}>18% VAT</Text>
            <Text style={[styles.cellTotal, styles.amountText]}>Rs.{vat.toFixed(2)}</Text>
          </View>
          <View style={styles.rowTotal}>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal]}></Text>
            <Text style={[styles.cellTotal, styles.labelText]}>Total Bill with VAT</Text>
            <Text style={[styles.cellTotal, styles.amountText]}>Rs.{totalWithVAT.toFixed(2)}</Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text>* Credit period 14 days.</Text>
          <Text>* Please acknowledge receipt by scanned mail to info@srikanthprofessional.com.</Text>
          <Text>* This is a computer generated invoice that does not require a signature.</Text>
          <Text>* Cheques to be drawn in favor of "Sri Kanth Professional Kitchen (Pvt) Ltd" and crossed "Account Payee".</Text>
        </View>

        {/* Page Number */}
        <Text
          style={{
            position: 'absolute',
            fontSize: 10,
            bottom: 10,
            right: 30,
          }}
          render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
        />
      </Page>
    </Document>
  );
};

export default InvoicePDF;
